import React from "react";
import logoSrc from '../img/logo.png';
import './Sales.css';

function ChambersOfShigjeta() {
  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">ignite innovation, spark growth.</h1>
            <p className="banner-description">
              The core of our business is built on collaboration, strategy, and innovation. Learn more about the chambers where these ideas come to life.
            </p>
            <a href="/chamber-formular" className="banner-button">
              Become an Chamber
            </a>
          </div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Sales Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* About Section */}
      <section className="about-section">
        {/* Chamber 1 */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Geographical Advantage Representation</strong></h2>
            <p>
            The Chamber of Shigjeta bridges our organization with key global regions—Europe, USA, and Asia—ensuring strong communication and fostering collaboration across diverse markets.
            </p>
            <ul>
              <li><strong>Europe:</strong> Navigating complex economies and political landscapes to strengthen ties through trade and cultural exchange.</li>
              <li><strong>USA:</strong> Leveraging economic power and technological leadership to drive business expansion and development.</li>
              <li><strong>Asia:</strong> Facilitating trade, investments, and partnerships to unlock growth opportunities in the rapidly developing region.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/s3.1.png" alt="Innovation Chamber" />
          </div>
        </div>

        {/* Chamber 2 */}
        <div className="about-row reverse">
        <div className="about-text">
  <h2><strong>Chamber Project Initiatives</strong></h2>
  <p>
    The Chamber Project Initiatives empower our ambassadors to drive strategic growth and collaboration across key regions. By managing projects of varying scales, our ambassadors foster business expansion, partnerships, and innovation to strengthen our global presence.
  </p>
  <ul>
    <li><strong>Dardanita:</strong> Projects from €10k to €100k – focused on small-scale ventures.</li>
    <li><strong>Ilirida:</strong> Projects from €100k to €1M – aimed at medium-scale market expansion.</li>
    <li><strong>Arberita:</strong> Projects from €1M to €10M – supporting large-scale growth and partnerships.</li>
    <li><strong>Albanita:</strong> Projects from €10M to €100M – driving major market developments and innovations.</li>
  </ul>
</div>
          <div className="about-image">
            <img src="/img/s3.2.png" alt="Leadership Chamber" />
          </div>
        </div>

        {/* Chamber 3 */}
        <div className="about-row">
        <div className="about-text">
  <h2><strong>Role and Responsibilities of the Research Chamber</strong></h2>
  <p>
    The Research Chamber is committed to providing essential insights, supporting strategic decisions, and guiding the development of Shigjeta LLC's initiatives. Below are the key responsibilities:
  </p>
  <ul>
    <li><strong>Market Analysis:</strong> Conduct in-depth analysis of market dynamics to identify emerging trends and growth opportunities.</li>
    <li><strong>Data-Driven Insights:</strong> Provide actionable insights based on data analytics to inform key business decisions.</li>
    <li><strong>Trend Forecasting:</strong> Predict future industry movements to help Shigjeta LLC stay ahead of competitors.</li>
    <li><strong>Competitor Research:</strong> Monitor and analyze competitors to identify strengths, weaknesses, and market gaps.</li>
    <li><strong>Strategic Recommendations:</strong> Offer recommendations based on research to guide the company's strategic planning and market entry.</li>
    <li><strong>Reporting:</strong> Provide regular reports on findings, trends, and data-backed insights to support decision-making processes.</li>
  </ul>
</div>

          <div className="about-image">
            <img src="/img/s3.3.png" alt="Research Chamber" />
          </div>
        </div>

        {/* Chamber 4 */}
        <div className="about-row reverse">
        <div className="about-text">
  <h2><strong>Synergy Chamber</strong></h2>
  <p>
    The Collaboration Chamber is designed to foster partnerships, connect businesses, and drive collective innovation. Through strategic collaboration, we create synergies that enable mutual growth and strengthen our presence in global markets.
  </p>
  <ul>
    <li><strong>Partnership Development:</strong> Building and nurturing strategic alliances for long-term success.</li>
    <li><strong>Cross-Industry Collaboration:</strong> Facilitating cooperation across industries to unlock new opportunities.</li>
    <li><strong>Global Networking:</strong> Connecting businesses globally to share resources, knowledge, and expertise.</li>
    <li><strong>Innovation Partnerships:</strong> Partnering with innovators to drive technological and business advancements.</li>
  </ul>
</div>
          <div className="about-image">
            <img src="/img/s3.4.png" alt="Collaboration Chamber" />
          </div>
        </div>
      </section>
    </>
  );
}

export default ChambersOfShigjeta;
